module.exports = "<app-overlay id=\"loader\" class=\"loading overlay\" *ngIf=\"loader.loading\">\n  <div\n    id=\"progress\"\n    class=\"color-contrast\"\n    [ngStyle]=\"{width: loader.progress * 100 + '%'}\"\n  ></div>\n  <div class=\"loader\"></div>\n  <span>{{ loader.info }}</span>\n</app-overlay>\n"


//////////////////
// WEBPACK FOOTER
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/ui-shared/loader/loader.component.html
// module id = ../../../../../src/app/ui-shared/loader/loader.component.html
// module chunks = main